/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsTrackLoadDesignRequest
 */
export interface EodMelcoEodModelsTrackLoadDesignRequest {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsTrackLoadDesignRequest
     */
    machine_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsTrackLoadDesignRequest
     */
    device_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsTrackLoadDesignRequest
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsTrackLoadDesignRequest
     */
    file_signature?: string | null;
}

export function EodMelcoEodModelsTrackLoadDesignRequestFromJSON(json: any): EodMelcoEodModelsTrackLoadDesignRequest {
    return EodMelcoEodModelsTrackLoadDesignRequestFromJSONTyped(json, false);
}

export function EodMelcoEodModelsTrackLoadDesignRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsTrackLoadDesignRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machine_name': !exists(json, 'machine_name') ? undefined : json['machine_name'],
        'device_id': !exists(json, 'device_id') ? undefined : json['device_id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'file_signature': !exists(json, 'file_signature') ? undefined : json['file_signature'],
    };
}

export function EodMelcoEodModelsTrackLoadDesignRequestToJSON(value?: EodMelcoEodModelsTrackLoadDesignRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machine_name': value.machine_name,
        'device_id': value.device_id,
        'file_name': value.file_name,
        'file_signature': value.file_signature,
    };
}


